import { Row, Col } from "antd";
import { Group } from "@dreambigger/design-system/src/components";
import { Header, CodeVerification } from "../../components";
import LoginForm from "./LoginForm";
import styles from "../start.module.scss";
import { StartTemplateProps } from "./types";

export default function TrianglesTemplate({
  assets,
  brand,
  flow,
  hideHeader,
  loginForm,
  keyByLoginMode,
  formattedCred,
  emailInputRef,
  phoneInputRef,
  handleNext,
  isAdminMode,
  codeVerificationProps,
}: StartTemplateProps) {
  const default_triangle_img =
    "https://res.cloudinary.com/cotribute/image/upload/v1656016221/acquire/template_assets/triangle-woman-on-laptop.png";

  return (
    <div className={`${styles.homePage} w-100 h-100 min-h-100vh`}>
      {!hideHeader && <Header brand={brand} />}

      <Group
        className={`w-100 flex-column-reverse lg_flex-row lg_tl lg_pt-8 md_pa-0`}
        style={{
          background: assets.heroBackground
            ? `url(${assets.heroBackground})`
            : `linear-gradient(180deg, rgba(${
                assets.heroBackgroundColor1 || "249,249,249"
              }) 0%, rgba(${
                assets.heroBackgroundColor2 || "249,249,249"
              }) 100%)`,
        }}
      >
        {/* LEFT COLUMN - Hidden on mobile */}
        <div className="dn lg_flex lg_w-45">
          <img
            className="w-100 lg_absolute"
            style={{ maxWidth: "40vw", top: "55px", left: "20px" }}
            src={assets.heroImage || default_triangle_img}
          />
        </div>
        {/* RIGHT COLUMN */}
        <div className="lg_w-55">
          <div className="flex flex-column w-100 lg_w-90">
            <div className="flex flex-column pl-5 lg_pl-0 pr-5">
              <h1
                className={`textSecondary mb-5 lh-1 f-9 xl_f-10 fwt mt-6 sm_mt-7 lg_mt-0`}
                dangerouslySetInnerHTML={{
                  __html: assets.title ?? "",
                }}
              />
              <h2
                className={`textSecondary f-7 md_f-8 xxl_f-9 lh-1`}
                dangerouslySetInnerHTML={{
                  __html: assets.subTitle ?? "",
                }}
              />
              <span
                className={`textSecondary f-5 md_f-6 xl_f-6 xxl_f-7 lh-2 mt-4 md_ph-0 tl pt-4 sm_pt-0`}
                dangerouslySetInnerHTML={{
                  __html: assets.description ?? "",
                }}
              />
              <LoginForm
                form={loginForm}
                loginMode={flow.financialInstitution.loginMode}
                keyByLoginMode={keyByLoginMode}
                formattedCred={formattedCred}
                loginTitle={assets.loginTitle}
                loginPlaceholder={assets.loginPlaceholder}
                submitButtonText={assets.submitButtonText}
                emailInputRef={emailInputRef}
                phoneInputRef={phoneInputRef}
                onFinish={handleNext}
                isAdminMode={isAdminMode}
              />
            </div>
            <Col
              className="flex flex-column lg_dn w-100 justify-center"
              style={{
                background: `linear-gradient(180deg, rgba(255, 0, 0 ,0) 0%, rgba(255, 255, 255) 60%)`,
                top: "10px",
              }}
            >
              <img
                className="w-100 ph-8"
                src={assets.heroImage || default_triangle_img}
              />
            </Col>
          </div>
        </div>
      </Group>

      <Row className="w-100 flex-row-reverse">
        <div className="w-100 lg_w-55 pv-5 ph-5 lg_pr-10 lg_tl">
          <div
            className="fwt tc sm_tl f-5 xl_f-5 xxl_f-6"
            dangerouslySetInnerHTML={{
              __html: assets.landingTermsTitle ?? "",
            }}
          />
          <div
            className={`${styles.terms} f-3 xl_f-4 xxl_f-5`}
            dangerouslySetInnerHTML={{
              __html: assets.landingTermsText ?? "",
            }}
          />
        </div>
      </Row>
      <CodeVerification {...codeVerificationProps} />
    </div>
  );
}
